import { v4 as uuidv4 } from "uuid";

let createGetTareasSolicitud = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk,
  parseError
}) => solicitudId => {
  let request = buildRequestWithAuth("GET");

  return fetch(
    `${environment.originacionUrl}/solicitudes/${solicitudId}/tareas/solicitadas`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      let resultError = parseError(error, "createGetTareasSolicitud");
      console.error(resultError);
      throw resultError;
    });
};

let createPostTarea = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk,
  parseError
}) => (solicitudId, sequence, body) => {
  let request = buildRequestWithAuth("POST", body);

  return fetch(
    `${environment.originacionUrl}/solicitudes/${solicitudId}/tareas/${sequence}/estado/para_analizar`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      let resultError = parseError(error, "createPostTarea");
      console.error(resultError);
      throw resultError;
    });
};

let createPostTareaConyuge = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk,
  parseError
}) => (solicitudId, data) => {
  let request = buildRequestWithAuth("POST", data);

  return fetch(
    `${environment.originacionUrl}/solicitudes/${solicitudId}/tareas/conyuge/para_analizar`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      let resultError = parseError(error, "createPostTareaConyuge");
      console.error(resultError);
      throw resultError;
    });
};

let createPostTareaTelefono = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk,
  parseError
}) => (solicitudId, data) => {
  let request = buildRequestWithAuth("POST", data);

  return fetch(
    `${environment.originacionUrl}/solicitudes/${solicitudId}/tareas/telefono/para_analizar`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      let resultError = parseError(error, "createPostTareaTelefono");
      console.error(resultError);
      throw resultError;
    });
};

let createPostTareaCodeudor = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk,
  parseError
}) => (solicitudId, data) => {
  let request = buildRequestWithAuth("POST", data);

  return fetch(
    `${environment.originacionUrl}/solicitudes/${solicitudId}/tareas/codeudor/para_analizar`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      let resultError = parseError(error, "createPostTareaCodeudor");
      console.error(resultError);
      throw resultError;
    });
};

export {
  createGetTareasSolicitud,
  createPostTarea,
  createPostTareaConyuge,
  createPostTareaCodeudor,
  createPostTareaTelefono
};
